/** URL canonique unique (apex, sans www) — alignée sur la prod Netlify. */
export const SITE_URL = 'https://rintintin-booking.com';

/** Page d’accueil vitrine Booking (hero + recherche). */
export const BOOKING_LANDING_PATH = '/';

/** Résultats de recherche (métier + zone) — pas d’annuaire public /pros. */
export const SEARCH_RESULTS_PATH = '/recherche';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
